import { accountScoped } from './activeAccount';

/**
 * The region last shown on the Segmentation matrix or the Segments page, per
 * account: moving between the two keeps the region a person picked, and a
 * page does not land somewhere different each visit.
 *
 * A per-browser convenience, never authoritative: the stored id can name a
 * region that has since been deleted or belongs to an organization the user
 * has left, so every read is validated against the regions the API returns
 * and discarded when it does not survive.
 */
const LAST_REGION_KEY = 'segmentation.lastRegionId';

export function readLastRegion(): string | null {
  try {
    return localStorage.getItem(accountScoped(LAST_REGION_KEY));
  } catch {
    // Private windows and blocked site data throw on access rather than
    // returning null, and a page should not fail to load over a preference.
    return null;
  }
}

export function rememberRegion(id: string) {
  try {
    localStorage.setItem(accountScoped(LAST_REGION_KEY), id);
  } catch {
    /* not worth surfacing: the page works, it just will not remember. */
  }
}

/** Forget `id` if it is the remembered region — one that no longer resolves. */
export function forgetRegion(id: string) {
  try {
    if (localStorage.getItem(accountScoped(LAST_REGION_KEY)) === id) {
      localStorage.removeItem(accountScoped(LAST_REGION_KEY));
    }
  } catch {
    /* nothing to do */
  }
}
